// Core & Styles
import * as React from "react";
import * as ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import App from "./App";
import AuthLayout from "./auth/Layout";
import AdminOnlyRoute from "./components/AdminOnlyRoute";

import Login from "./auth/Login";
import Register from "./auth/Register";
// Dashboard
import Dashboard from "./pages/Dashboard";
// History
import History from "./pages/history/index";
import ListHistory from "./pages/history/History";
import HistoryDetail from "./pages/history/HistoryDetail";
import BowMedicalHistoryDetail from "./pages/history/BowMedicalHistoryDetail";
// History
import ServiceVaccine from "./pages/service/service";
import ServiceMicrochip from "./pages/service/service_microchip";
import ServiceParasite from "./pages/service/service_parasite";
// Users
import Users from "./pages/users/index";
import ListUsers from "./pages/users/Users";
import UserDetail from "./pages/users/UserDetail";
import UserRegister from "./pages/users/Register";
// Pet
import Pet from "./pages/pets/index";
import PetDetail from "./pages/pets/PetDetail";
import PetConnect from "./pages/pets/PetConnect";
import PetHistoryList from "./pages/pets/PetHistoryList";
import PetList from "./pages/pets/PetList";
import PetCreate from "./pages/pets/PetCreate";
import ConnectionRequestList from "./pages/pets/ConnectionRequestList";
import ConnectionRequestDetail from "./pages/pets/ConnectionRequestDetail";
import Owner from "./pages/owner/index";
import OwnerList from "./pages/owner/ownerList";
import OwnerEdit from "./pages/owner/ownerEdit";
import OwnerCreate from "./pages/owner/ownerCreate";
import MyHospitalEditForm from "./pages/setting/hospitalEditForm";
import ProfileEditForm from "./pages/setting/profileEditForm";
import ProfilePage from "./pages/setting";
//Hospital
import Hospital from "./pages/hospital/index";
import HospitalListPage from "./pages/hospital/hospitalList";
import HospitalCreatePage from "./pages/hospital/hospitalCreate";
import HospitalEditPage from "./pages/hospital/hospitalEdit";
import ForgotPassword from "./auth/Forgot";
import ResetPassword from "./auth/Reset";
import StaffCreate from "./pages/hospital/hospitalStaffCreate";
import EditStaff from "./pages/hospital/hospitalStaffEdit";
import MobileLogin from "./mobile/MobileLogin";
import MobileHome from "./mobile/MobileHome";
import MobileProtectedRoute from "./mobile/MobileProtectedRoute";
import MobileServicePage from "./mobile/MobileServicePage";

const router = createBrowserRouter([
  {
    Component: App,
    children: [
      {
        path: "/",
        children: [
          {
            path: "",
            Component: Dashboard,
          },
          {
            path: "/medical_history",
            Component: History,
            children: [
              {
                path: "",
                Component: ListHistory,
              },
              {
                path: ":id",
                Component: HistoryDetail,
              },
            ],
          },
          {
            path: "/bow_medical_history",
            Component: History,
            children: [
              {
                path: ":id",
                Component: BowMedicalHistoryDetail,
              },
            ],
          },
          {
            path: "/service",
            // Component: ServiceVaccine,
            children: [
              {
                path: "vaccine",
                Component: ServiceVaccine,
              },
              {
                path: "microchip",
                Component: ServiceMicrochip,
              },
              {
                path: "parasite",
                Component: ServiceParasite,
              },
            ],
          },
          {
            path: "/users",
            Component: Users,
            children: [
              {
                path: "",
                Component: ListUsers,
              },
              {
                path: ":id",
                Component: UserDetail,
              },
              {
                path: "register",
                Component: UserRegister,
              },
            ],
          },
          {
            path: "/pets",
            Component: Pet,
            children: [
              {
                path: "history",
                Component: PetHistoryList,
              },
              {
                path: ":id",
                Component: PetDetail,
              },
              {
                path: ":id/connect",
                Component: PetConnect,
              },
              {
                path: "create",
                Component: PetCreate,
              },
              {
                path: "list",
                Component: PetList,
              },
              {
                path: "connection-requests",
                Component: ConnectionRequestList,
              },
              {
                path: "connection-requests/:id",
                Component: ConnectionRequestDetail,
              },
            ],
          },
          {
            path: "/owner",
            Component: Owner,
            children: [
              {
                path: "list",
                Component: OwnerList,
              },
              {
                path: "create",
                Component: OwnerCreate,
              },
              {
                path: ":id",
                Component: OwnerEdit,
              },
            ],
          },
          {
            path: "/dashboard",
            Component: Dashboard,
            // children: [
            //   {
            //     path: "",
            //     Component: PetList,
            //   },
            //   {
            //     path: ":id",
            //     Component: PetDetail,
            //   },
            // ],
          },
          {
            path: "/profile",
            Component: ProfilePage,
            children: [
              {
                path: "",
                Component: ProfileEditForm,
              },
              {
                path: "",
                Component: MyHospitalEditForm,
              },
            ],
          },
          {
            path: "/hospitals",
            Component: AdminOnlyRoute,
            children: [
              {
                path: "",
                Component: Hospital,
                children: [
                  {
                    path: "list",
                    Component: HospitalListPage,
                  },
                  {
                    path: "create",
                    Component: HospitalCreatePage,
                  },
                  {
                    path: ":id",
                    Component: HospitalEditPage,
                  },
                  {
                    path: "users/create",
                    Component: StaffCreate,
                  },
                  {
                    path: "users/:id",
                    Component: EditStaff
                  }
                ],
              }
            ],
          },
        ],
      },
    ],
  },
  {
    path: "/auth",
    Component: AuthLayout,
    children: [
      {
        path: "login",
        Component: Login,
      },
      {
        path: "register",
        Component: Register,
      },
      {
        path: "forgot-password",
        Component: ForgotPassword,
      },
      {
        path: "reset-password",
        Component: ResetPassword,
      },
    ],
  },
  {
    path: "/mobile/login",
    Component: MobileLogin,
  },
  {
    path: "/mobile",
    Component: MobileProtectedRoute,
    children: [
      {
        path: "",
        Component: MobileHome,
      },
      {
        path: "service/:type",
        Component: MobileServicePage,
      },
    ],
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <RouterProvider router={router} />,
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
